import { HpDatasetDto } from '../shell-communication/dtos/hp-dataset-dto.class';

export abstract class HpDatasetsBackendService {
  abstract getDatasetsForStrategy(strategyId: string): Promise<HpDatasetDto[]>;
}
